import NotAuthorized from './not-authorized.vue'

export default {
  name: 'not-authorized',
  path: '/accounts/not-authorized',
  component: NotAuthorized,
  meta: {
    secure: true
  }
}
